import { render, staticRenderFns } from "./ConsultManage.vue?vue&type=template&id=66a639fa&"
import script from "./ConsultManage.vue?vue&type=script&lang=js&"
export * from "./ConsultManage.vue?vue&type=script&lang=js&"
import style0 from "./ConsultManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports